import { Icon } from "@iconify/react";
import React, { useState } from "react";
import ic_playlist from "../../assets/icons/ic_playlist_white.svg";
import InstructionDialog from "../home/InstructionDialog";

function Playlist({ duration, activityImage, mainName, subName, url }) {
  const [showStartDialog, setShowStartDialog] = useState(false);
  return (
    <>
      <InstructionDialog
        show={showStartDialog}
        close={() => {
          setShowStartDialog(false);
        }}
        allowDontShow={false}
        redirectUrl={url}
      />
      <div className="group flex flex-1 flex-col rounded-2xl  shadow-xl -z-0 w-full min-h-[200px] max-h-full">
        <div
          className="flex flex-1 transform rounded-2xl h-full hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500  w-full"
          onClick={() => {
            setShowStartDialog(true);
          }}
        >
          <div
            style={{ backgroundImage: `url(${activityImage})` }}
            className={` bg-center  bg-cover rounded-b-2xl rounded-t-xl w-full h-full flex flex-col`}
          >
            <div
              className={`bg-black bg-opacity-60 rounded-b-2xl rounded-t-xl h-full`}
            >
              <div className="flex flex-col h-full">
                <div className="px-2 pt-8 pb-2 space-y-2 flex flex-1 flex-col  justify-end items-start rounded-xl ">
                  <p
                    className={`font-open-sans text-xs font-medium text-center text-primary-neonGreen italic   `}
                  >
                    EXPERIENCE
                  </p>
                  <p className="font-bold font-open-sans text-white text-lg md:text-2xl uppercase">
                    {mainName}
                  </p>
                </div>
                <div
                  className={`px-2 md:px-4 py-1 flex flex-row bg-[#3C4647] items-center rounded-b-xl`}
                >
                  {duration && (
                    <div className="flex items-center gap-x-1">
                      <img src={ic_playlist} />
                      <p className="font-medium text-sm uppercase text-primary-white">
                        {duration} MINUTES
                      </p>
                    </div>
                  )}
                  <div className="flex flex-1"></div>
                  <Icon
                    icon="material-symbols:play-circle"
                    className="text-primary-neonGreen w-7 h-7"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export function ExperienceGetactyv() {
  return (
    <div className="w-full relative flex flex-col bg-primary-lightBlack rounded-xl p-8">
      <div className=" flex flex-col justify-center pb-4">
        <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug">
          Experience <span className="text-primary-neonGreen">Getactyv</span>
        </p>
        <p className=" text-white mt-2 items-center">pick any workout</p>
      </div>
      <div className="w-full grid grid-cols-1 md:grid-cols-3 mt-5 gap-5">
        {[
          {
            duration: 3,
            activityImage:
              "https://getactyvfitness.blob.core.windows.net/images/exercises/jumping_jacks.jpg",
            mainName: "Beginner",
            url: "https://app.getactyvphysio.com/sample?id=Beginner",
          },
          {
            duration: 5,
            activityImage: "https://getactyvfitness.blob.core.windows.net/images/exercises/squats.jpg",
            mainName: "Intermediate",
            url: "https://app.getactyvphysio.com/sample?id=Intermediate",
          },
          {
            duration: 7,
            activityImage:
              "https://getactyvfitness.blob.core.windows.net/images/exercises/EX_Bearhold.jpg",
            mainName: "Advanced",
            url: "https://app.getactyvphysio.com/sample?id=Advanced",
          },
        ].map((playlist) => {
          return <Playlist {...playlist} />;
        })}
      </div>
    </div>
  );
}
